module.exports = __webpack_public_path__ + "img/4.full.737252bb.webp";